export function roundTwoPlacesAfterDecimalPoint(value: any) {
  return (Math.round((Number(value) ?? 0) * 100) / 100).toFixed(2);
}
